import { HttpResponse } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToasterService } from 'angular5-toaster/dist';
import { Observable } from 'rxjs';
import { WordCloudSetting } from '../../../models/settings/word-cloud-setting';
import { ValidationService } from '../../../shared/components/control-messages/validation.service';
import { WordCloudSettingsService } from './word-cloud-settings.service';

@Component({
  selector: 'app-word-cloud-settings',
  templateUrl: './word-cloud-settings.component.html',
  styleUrls: ['./word-cloud-settings.component.less']
})
export class WordCloudSettingsComponent implements OnInit {

  setting: WordCloudSetting;

  cloudSettingForm = this.fb.group({
    maxCountPerColor: [1, Validators.compose([Validators.min(1), Validators.max(99)])],
    threshold: [1, Validators.compose([Validators.min(1), Validators.max(99)])],
    exceptionWords:[null, Validators.compose([ValidationService.specialCharacterValidator])],
    maxWordCount: [1, Validators.compose([Validators.min(1), Validators.max(99)])],
    
  });
  nolimitMaxCountColor = false;
  nolimitThreshold = false;
  nolimitMaxWordCount = false;
  isSaving = false;
  exceptionWords: string[];
  selectorSize = 30;
  reducer = (accumulator, currentValue) => accumulator +'\n' + currentValue;
  constructor(private wordCloudSettingsService: WordCloudSettingsService,
    private toast: ToasterService, protected fb: FormBuilder, private router: Router) { 
    }


  ngOnInit() {
    this.setting = new WordCloudSetting();
    this.getGlobalCloudSetting();
  }

  getGlobalCloudSetting() {
     this.wordCloudSettingsService.getGlobalCloudSetting().subscribe(res => {
      this.setting = res;
      this.updateForm(this.setting);
      // this.toast.pop('success', 'Update successful!');
    }, _ => {
      // this.toast.pop('error', 'Something went wrong');
    });
    
  }
  
  updateForm(setting: WordCloudSetting): void {
    this.exceptionWords = setting.exceptionWords.split(',');
    let exceptionValue = this.exceptionWords.reduce(this.reducer);
    this.nolimitMaxWordCount = setting.maxWordCount === -1;
    this.nolimitMaxCountColor = setting.maxCountPerColor === -1;
    this.nolimitThreshold = setting.wordCountThreshold === -1;
    this.cloudSettingForm.patchValue({
      font: setting.font,
      maxCountPerColor: this.nolimitMaxCountColor? 1 : setting.maxCountPerColor,
      threshold: this.nolimitThreshold ? 1 : setting.wordCountThreshold,
      exceptionWords: exceptionValue,
      maxWordCount: this.nolimitMaxWordCount? 1 :setting.maxWordCount
    })
  }

  saveOrUpdate(): void {
    this.isSaving = true;
    const setting = this.createFromForm();
      this.subscribeToSaveResponse(this.wordCloudSettingsService.updateGlobalCloudSetting(setting));

  }
  
  protected subscribeToSaveResponse(result: Observable<HttpResponse<WordCloudSetting>>): void {
    result.subscribe(
      () => this.onSaveSuccess(),
      () => this.onSaveError()
    );
  }

  protected onSaveSuccess(): void {
    this.toast.pop('success', 'Update successful!');
    this.isSaving = false;
  }

  protected onSaveError(): void {
    this.toast.pop('error', 'Something went wrong');
    this.isSaving = false;
  }

  private createFromForm(): WordCloudSetting {
    const exceptionWordVal = this.cloudSettingForm.get(['exceptionWords'])!.value.replaceAll('\n', ',');
    return {
      ...new WordCloudSetting(),
      maxCountPerColor: this.nolimitMaxCountColor? -1 : this.cloudSettingForm.get(['maxCountPerColor'])!.value,
      wordCountThreshold: this.nolimitThreshold ? -1 : this.cloudSettingForm.get(['threshold'])!.value,
      exceptionWords: exceptionWordVal,
      maxWordCount: this.nolimitMaxWordCount ? -1 : this.cloudSettingForm.get(['maxWordCount'])!.value,
    };
  }
  changeNolimitmaxCountPerColor() {
    this.nolimitMaxCountColor = !this.nolimitMaxCountColor;
    if(!this.nolimitMaxCountColor){
      this.cloudSettingForm.patchValue({
        maxCountPerColor: 1
      });
    }
  }

  changeNolimitmaxWordCount() {
    this.nolimitMaxWordCount = !this.nolimitMaxWordCount;
    if(!this.nolimitMaxWordCount){
      this.cloudSettingForm.patchValue({
        maxWordCount: 1
      });
    }
  }

  changeNolimitThreshold() {
    this.nolimitThreshold = !this.nolimitThreshold;
    if(!this.nolimitThreshold){
      this.cloudSettingForm.patchValue({
        threshold: 1
      });
    }
  }
  changeInputValue(event) {
    if (event.key === "." ||
        event.key === "-" ||
        event.key === "e" ||
        event.key === "E") {
      event.preventDefault();
    }
  }

  cancel() {
    this.router.navigate(['surveys']);
  }
  formateString(str) {
    var strArray = str.split("\n");
    strArray = strArray.filter((item) => {
      return item !== '';
    });
    return strArray.join(",").split(",,").join(",");
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/settings/word-cloud-settings/word-cloud-settings.component.ts